import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import getText from '../../assets/locale/locale';
import { LocaleContext } from '../../contexts/index';
import './Error.scss';

const Error = ({ quizStarted, setQuizStarted, setErrorOccurred }) => {
  const locId = useContext(LocaleContext);
  const location = useLocation();

  const resetWelcomePage = () => {
    setQuizStarted(false);
    setErrorOccurred(false);
  };

  return (
    <div className="ErrorPage" data-testid="errorPage">
      <div className="ErrorPage_message">
        <p id="heading-no-focus">
          {`${getText(locId, 'Error', 'errorTextLine1')}`}
        </p>
        <p>{`${getText(locId, 'Error', 'errorTextLine2')}`}</p>
        {quizStarted ? (
          <div className="ErrorPage_welcome-page-link">
            <p>
              <Link
                data-testid="welcome-page-link"
                to={{ pathname: '/', search: location.search }}
                onClick={() => resetWelcomePage()}
                className="link"
              >
                {getText(locId, 'Error', 'firstPageLinkText')}
              </Link>
              .
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

Error.propTypes = {
  quizStarted: PropTypes.bool.isRequired,
  setQuizStarted: PropTypes.func.isRequired,
  setErrorOccurred: PropTypes.func.isRequired,
};

export default Error;
